import React from 'react';
import { AdminLayout } from '../components/custom/AdminLayout';
import AnalyticsPage from './AnalyticsPage';

function AnalyticsPageWrapper() {
  return (
    <AdminLayout>
      <AnalyticsPage />
    </AdminLayout>
  );
}

export default AnalyticsPageWrapper;
